import { ApiService } from "./api.service";
import type { TState } from "@/types/issue-metadata";

export interface TStateCreateData {
  name: string;
  color: string;
  group: TState["group"];
  description?: string | null;
}

export interface TStateUpdateData {
  name?: string;
  color?: string;
  group?: TState["group"];
  description?: string | null;
  sequence?: number;
}

export class WorkItemStateService extends ApiService {
  async list(slug: string): Promise<TState[]> {
    return this.get(`/api/workspaces/${slug}/work-item-states/`);
  }

  async create(slug: string, data: TStateCreateData): Promise<TState> {
    return this.post(`/api/workspaces/${slug}/work-item-states/`, data);
  }

  async update(slug: string, stateId: string, data: TStateUpdateData): Promise<TState> {
    return this.patch(`/api/workspaces/${slug}/work-item-states/${stateId}/`, data);
  }

  async remove(slug: string, stateId: string): Promise<void> {
    return this.delete(`/api/workspaces/${slug}/work-item-states/${stateId}/`);
  }

  async markDefault(slug: string, stateId: string): Promise<TState> {
    return this.post(`/api/workspaces/${slug}/work-item-states/${stateId}/mark-default/`, {});
  }
}
